export interface ErrorEntry {
  message: string;
  filename: string;
  lineno: number;
  colno: number;
  stack: string;
  timestamp: string;
  type: 'error' | 'unhandledrejection';
}

const buffer: ErrorEntry[] = [];
let listening = false;

function onError(event: ErrorEvent): void {
  buffer.push({
    message: event.message || 'Unknown error',
    filename: event.filename || '',
    lineno: event.lineno || 0,
    colno: event.colno || 0,
    stack: event.error?.stack || '',
    timestamp: new Date().toISOString(),
    type: 'error',
  });
}

function onUnhandledRejection(event: PromiseRejectionEvent): void {
  const reason = event.reason;
  buffer.push({
    message: reason instanceof Error ? reason.message : String(reason),
    filename: '',
    lineno: 0,
    colno: 0,
    stack: reason instanceof Error ? reason.stack || '' : '',
    timestamp: new Date().toISOString(),
    type: 'unhandledrejection',
  });
}

export function startErrorListener(): void {
  if (listening) return;
  listening = true;
  window.addEventListener('error', onError);
  window.addEventListener('unhandledrejection', onUnhandledRejection);
}

export function stopErrorListener(): void {
  if (!listening) return;
  listening = false;
  window.removeEventListener('error', onError);
  window.removeEventListener('unhandledrejection', onUnhandledRejection);
}

export function getErrors(): ErrorEntry[] {
  return [...buffer];
}
